<div *ngIf="!aktiv.ugyfelId" class="ures">
  <ion-icon name="business-outline"></ion-icon>
  Először válasszon ügyfelet az <b>Ügyfelek</b> fülön.
</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <!-- NAV-KAPCSOLAT: az AKTUÁLIS technikai felhasználóval, a beállítása szerinti környezetben -->
  <div class="n-panel eafa-kapcsolat" *ngIf="kapcsolat">
    <div class="n-panel-cim" style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">
      <ion-icon name="link-outline"></ion-icon> NAV-kapcsolat
      <span class="cimke" [class.zold]="kapcsolat.kesz" [class.sarga]="!kapcsolat.kesz">{{ kapcsolat.kesz ? 'hitelesítő kész' : 'nincs technikai felhasználó' }}</span>
      <span class="cimke" [class.petrol]="kapcsolat.kornyezet === 'teszt'" [class.piros]="kapcsolat.kornyezet === 'eles'">
        {{ kapcsolat.kornyezet === 'eles' ? 'ÉLES környezet' : 'Tesztkörnyezet' }}</span>
      <span class="spacer"></span>
      <button type="button" class="ov-gomb" [disabled]="kapFut === 'proba' || !kapcsolat.kesz" (click)="kapcsolatProba()">
        <ion-icon [name]="kapFut === 'proba' ? 'hourglass-outline' : 'pulse-outline'"></ion-icon>{{ kapFut === 'proba' ? 'Próba…' : 'Kapcsolat próbája' }}</button>
      <button type="button" class="ov-gomb" (click)="technikaiFelhasznalora()">
        <ion-icon name="key-outline"></ion-icon>Technikai felhasználó</button>
    </div>
    <p class="halvany" style="margin:0;font-size:12.5px">
      Az eÁFA azzal a NAV <b>technikai felhasználóval</b> dolgozik, amelyik az ügyfélnél be van állítva
      (<b>{{ kapcsolat.login || 'nincs megadva' }}</b>{{ kapcsolat.adoszam ? ' · ' + kapcsolat.adoszam : '' }}), és abba a NAV-világba,
      amit ott a „teszt (sandbox)" jelölés mond – most: <code>{{ kapcsolat.bazis }}</code>.
      A beállítás helye: <b>{{ kapcsolat.beallitas_helye }}</b>.
      <ng-container *ngIf="kapcsolat.utolso_proba"><br>Utolsó próba: {{ kapcsolat.utolso_proba | date:'yyyy.MM.dd HH:mm' }} – {{ kapcsolat.utolso_eredmeny }}</ng-container>
    </p>
  </div>

  <!-- ELLENŐRZŐ SOROK: a bevallás összesítői és a kontrollok (főkönyv, Online Számla, besorolás) -->
  <div class="n-panel eafa-ellenorzes" *ngIf="ellenorzes">
    <div class="n-panel-cim" style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">
      <ion-icon name="checkmark-done-outline"></ion-icon> Ellenőrző sorok – {{ ellenorzes.idoszak }}
      <span class="cimke" [class.zold]="ellenorzes.rendben" [class.sarga]="!ellenorzes.rendben">
        {{ ellenorzes.rendben ? 'minden kontroll rendben' : ellenorzes.kifogas + ' kifogás' }}</span>
      <span class="halvany">forrás: {{ ellenorzes.forras === 'konyveles-kettos' ? 'kettős könyvelés' : (ellenorzes.forras === 'osa' ? 'Online Számla' : 'könyvelés') }}</span>
      <span class="spacer"></span>
      <button type="button" class="ov-gomb" *ngIf="potolhato" [disabled]="ellFut || potlasFut" (click)="potlas()"
        title="A hiányzó áfakulcsok és bevallási sorok beírása a tételsorokra (az egész évre)">
        <ion-icon [name]="potlasFut ? 'hourglass-outline' : 'construct-outline'"></ion-icon>Utólagos pótlás ({{ potolhato }})</button>
      <button type="button" class="ov-gomb" [disabled]="ellFut" (click)="ellenorzesFrissit()">
        <ion-icon [name]="ellFut ? 'hourglass-outline' : 'refresh-outline'"></ion-icon>Újraszámolás</button>
    </div>
    <!-- Közösségi ügylet az időszakban: az A60-at is be kell adni (a kiszolgáló a könyvelésből méri). -->
    <div class="a60-jelzes" *ngIf="a60Sor as a">
      <ion-icon name="alert-circle-outline"></ion-icon>
      <div><b>Ebben az időszakban A60-ast (összesítő nyilatkozat) is be kell adni.</b> <span class="halvany">{{ a.uzenet }}</span></div>
      <button type="button" class="ov-gomb" (click)="a60Nyit()"><ion-icon name="document-attach-outline"></ion-icon>Bevallások</button>
    </div>
    <div class="tabla-wrap">
      <table class="n-racs">
        <thead><tr><th class="sorkod">Sor</th><th>Megnevezés</th><th class="num">Összeg</th><th>Ellenőrzés</th></tr></thead>
        <tbody>
          <tr *ngFor="let s of ellenorzes.sorok" [class.kontroll]="s.tipus === 'kontroll'" [class.baj]="s.ok === false">
            <td class="sorkod">{{ s.kod }}</td>
            <td>{{ s.cim }}</td>
            <td class="num"><ng-container *ngIf="s.ertek !== null && s.ertek !== undefined">{{ s.ertek | number:'1.0-0' }} Ft</ng-container>
              <!-- A bevallás ezer forintban számol, soronként kerekítve: ez kerül a beküldött összegzőbe. -->
              <small class="ezer" *ngIf="s.ezer !== null && s.ezer !== undefined" title="A bevallásba ezer forintra kerekítve kerül (soronként kerekítve)">
                bevallásban: {{ s.ezer | number:'1.0-0' }} ezer Ft</small></td>
            <td>
              <span class="cimke" *ngIf="s.ok !== undefined" [class.zold]="s.ok" [class.piros]="!s.ok">{{ s.ok ? 'rendben' : 'nézd meg' }}</span>
              <span class="halvany"> {{ s.uzenet || '' }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Időszak választó + analitika -->
  <div class="eafa-fejlec">
    <ion-segment [(ngModel)]="bontas" (ionChange)="frissitIdoszak()" style="max-width:260px">
      <ion-segment-button value="ho"><ion-label>Havi</ion-label></ion-segment-button>
      <ion-segment-button value="negyedev"><ion-label>Negyedéves</ion-label></ion-segment-button>
    </ion-segment>
    <ion-select [(ngModel)]="ev" (ionChange)="frissitIdoszak()" interface="popover" label="Év" style="max-width:110px">
      <ion-select-option *ngFor="let y of [ev+1, ev, ev-1, ev-2]" [value]="y">{{ y }}</ion-select-option>
    </ion-select>
    <ion-select *ngIf="bontas==='ho'" [(ngModel)]="hoSel" (ionChange)="frissitIdoszak()" interface="popover" label="Hónap" style="max-width:130px">
      <ion-select-option *ngFor="let h of honapok" [value]="h">{{ h }}. hó</ion-select-option>
    </ion-select>
    <ion-select *ngIf="bontas==='negyedev'" [(ngModel)]="qSel" (ionChange)="frissitIdoszak()" interface="popover" label="Negyedév" style="max-width:130px">
      <ion-select-option *ngFor="let qn of negyedevek" [value]="qn">{{ qn }}. né.</ion-select-option>
    </ion-select>
    <ion-select [(ngModel)]="forras" interface="popover" label="Forrás" style="max-width:230px"
      title="Miből álljon össze az ÁFA: a könyvelt tételekből, vagy közvetlenül a NAV Online Számla adataiból (könyvelés nélkül is)">
      <ion-select-option value="konyveles">Könyvelésből</ion-select-option>
      <ion-select-option value="osa">Online Számla adataiból</ion-select-option>
    </ion-select>
    <ion-button style="--background:var(--naplo)" (click)="analitika()">
      <ion-icon slot="start" name="calculator"></ion-icon> Áfa-analitika összeállítása
    </ion-button>
    <!-- Soronkénti ellenőrzéshez: nyomtatvány-szerű munkapéldány külön lapon (nyomtatható, PDF-be is). -->
    <ion-button fill="outline" (click)="munkapeldany()" [disabled]="!bevallas?.analitika"
                title="Nyomtatvány-szerű munkapéldány: bevallási soronként adóalap és adó – új lapon nyílik, nyomtatható">
      <ion-icon slot="start" name="document-text-outline"></ion-icon> Nyomtatvány (munkapéldány)
    </ion-button>
  </div>
  <p class="halvany" style="margin:-4px 16px 4px" *ngIf="forras==='osa'">
    Az <b>Online Számla adataiból</b> forrás a NAV-tól letöltött számlákból számol (könyvelés nélkül is).
    Ehhez előbb futtasd le a számla-szinkront a <b>NAV Számlázó</b> fülön.
  </p>

  <!-- Állapot-lépcső + M2M lépések -->
  <div class="eafa-lepesek" *ngIf="bevallas?.letezik">
    <div class="allapot-sav">
      <span class="cimke">Állapot ({{ bevallas.idoszak }}):</span>
      <ion-chip [color]="bevallas.allapot === 'bekuldve' ? 'success' : (bevallas.allapot === 'hiba' ? 'danger' : 'warning')">
        <ion-label>{{ bevallas.allapot }}</ion-label>
      </ion-chip>
      <span class="halvany" *ngIf="bevallas.utolso_muvelet">· {{ bevallas.utolso_muvelet }}</span>
    </div>
    <!--  A LÁNC SORRENDJE: feltöltés → véglegesítés (innen jön a feldolgozási azonosító) →
          állapot → tervezet → beküldés. A gombok csak akkor élnek, ha az előző lépés megvolt. -->
    <div class="lepes-gombok">
      <ion-button size="small" fill="outline" (click)="lepes('feltolt','Analitika feltöltése')" [disabled]="!bevallas.analitika">1. Feltöltés</ion-button>
      <ion-button size="small" fill="outline" (click)="lepes('veglegesit','Bevallás véglegesítése')"
                  [disabled]="!bevallas.transaction_id || !!bevallas.feldolgozas_id">2. Véglegesítés</ion-button>
      <ion-button size="small" fill="outline" (click)="lepes('status','Feldolgozás-állapot')" [disabled]="!bevallas.feldolgozas_id">3. Státusz</ion-button>
      <ion-button size="small" fill="outline" (click)="lepes('tervezet','Tervezet letöltése')" [disabled]="!bevallas.feldolgozas_id">4. Tervezet</ion-button>
      <ion-button size="small" color="success" (click)="lepes('bekuld','Bevallás beküldése')" [disabled]="!bevallas.feldolgozas_id">5. Beküldés</ion-button>
      <ion-button size="small" fill="clear" (click)="analitikaXml()" [disabled]="!bevallas.analitika"
                  title="A NAV-nak felküldött analitika-XML megtekintése">Felküldött XML</ion-button>
    </div>
    <!-- Épülő módosítás jelzése -->
    <div class="modositas-sav" *ngIf="bevallas.modositas_folyamatban">
      <ion-icon name="create-outline"></ion-icon>
      <b>{{ jellegNev(bevallas.jelleg, bevallas.nav_javitas) }}</b> készül – hivatkozás: <code>{{ bevallas.hivatkozas_id }}</code>, {{ bevallas.hivatkozas_index }}. módosítás
      <span *ngIf="bevallas.eredeti_osszegzo"> · eredeti különbözet: {{ bevallas.eredeti_osszegzo.kulonbozet_ezer }} eFt</span>
      <span *ngIf="bevallas.onell?.potlek"> · önellenőrzési pótlék: {{ bevallas.onell.potlek }} Ft</span>
      <span class="spacer"></span>
      <button type="button" class="ov-gomb" (click)="modositasElvet()" [disabled]="!!bevallas.feldolgozas_id">Elvetés</button>
    </div>
    <!-- Beküldött bevallás: törölni nem lehet – önellenőrzés, helyesbítés vagy javítás -->
    <div class="modositas-sav bekuldott" *ngIf="bevallas.allapot === 'bekuldve'">
      <ion-icon name="lock-closed-outline"></ion-icon>
      <span>A bevallás beküldve – törölni nem lehet. Módosítás:</span>
      <button type="button" class="ov-gomb" (click)="modositasNyit('SELF_CHECK')" title="Adózói önellenőrzés – 04-es lappal, pótlékkal">Önellenőrzés</button>
      <button type="button" class="ov-gomb" (click)="modositasNyit('CORRECTION')" title="Helyesbítés (pl. az adóhatósági ellenőrzés előtt, pótlék nélkül)">Helyesbítés</button>
      <button type="button" class="ov-gomb" (click)="modositasNyit('JAVITAS')" title="A NAV értesítő levele alapján, a 10 jegyű vonalkóddal">Javítás (NAV-felhívás)</button>
    </div>
    <table class="lanc" *ngIf="bevallas.lanc?.length">
      <thead><tr><th>#</th><th>Jelleg</th><th>Feldolgozási azonosító</th><th>Verzió</th><th class="num">Különbözet (eFt)</th><th>Beküldve</th></tr></thead>
      <tbody><tr *ngFor="let l of bevallas.lanc; let i = index">
        <td>{{ i }}</td><td>{{ jellegNev(l.jelleg, l.nav_javitas) }}</td><td><code>{{ l.feldolgozas_id }}</code></td><td>{{ l.verzio }}</td>
        <td class="num">{{ l.osszegzo?.kulonbozet_ezer }}</td><td>{{ l.bekuldve ? (l.bekuldve | date:'yyyy.MM.dd HH:mm') : '' }}</td>
      </tr></tbody>
    </table>
    <p class="halvany nav-uzenet" *ngIf="bevallas.nav_uzenet">NAV: {{ bevallas.nav_uzenet }}</p>
    <p class="halvany" style="margin:0 0 4px;font-size:12.5px" *ngIf="bevallas.verzio">
      Feltöltött verzió: <b>{{ bevallas.verzio }}</b>
      <span *ngIf="bevallas.transaction_id"> · feltöltés-azonosító: <code>{{ bevallas.transaction_id }}</code></span>
      <span *ngIf="bevallas.feldolgozas_id"> · feldolgozási azonosító: <code>{{ bevallas.feldolgozas_id }}</code></span>
    </p>

    <!--  AZ UTOLSÓ NAV-LÉPÉS EREDMÉNYE. Eddig a nyers XML-t láttuk itt; most azt mutatjuk, amit a
          könyvelő kezdeni tud vele: mit mondott a NAV, és mely analitika-soroknál kifogásolt. -->
    <div class="nav-eredmeny" *ngIf="utolsoLepes as u" [class.baj]="u.baj">
      <div class="fej">
        <ion-icon [name]="u.baj ? 'alert-circle-outline' : 'checkmark-circle-outline'"></ion-icon>
        <b>{{ u.cimke }}</b>
        <span class="cimke" *ngIf="u.feldolgozas">feldolgozás: {{ u.feldolgozas.szoveg }}</span>
        <span class="cimke" *ngIf="u.kornyezet">{{ u.kornyezet === 'eles' ? 'ÉLES' : 'teszt' }}</span>
        <span class="spacer"></span>
        <button type="button" class="ov-gomb" (click)="utolsoLepes = null">Bezár</button>
      </div>
      <p *ngIf="u.uzenet">{{ u.uzenet }}</p>
      <p class="halvany" *ngIf="u.magyarazat">{{ u.magyarazat }}</p>
      <p class="figyelem" *ngIf="u.figyelmeztetes">{{ u.figyelmeztetes }}</p>
      <div class="tabla-wrap" *ngIf="u.hibak?.length">
        <table class="n-racs">
          <thead><tr><th>Sor</th><th>Mező</th><th>Érték</th><th>A NAV kifogása</th></tr></thead>
          <tbody>
            <tr *ngFor="let h of u.hibak" [class.baj]="h.szint === 'ERROR'">
              <td>{{ h.sor || '—' }}</td><td>{{ h.mezo || '—' }}</td><td>{{ h.ertek || '—' }}</td>
              <td>{{ h.uzenet }} <span class="halvany">({{ h.kod }})</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--  A NAV ÁLTAL ÖSSZEÁLLÍTOTT TERVEZET: amit a 4. lépés lehozott. -->
    <div class="nav-eredmeny tervezet" *ngIf="bevallas.tervezet as t">
      <div class="fej">
        <ion-icon name="document-text-outline"></ion-icon><b>A NAV bevallás-tervezete</b>
        <span class="halvany" *ngIf="t.lekerve">lekérve: {{ t.lekerve | date:'yyyy.MM.dd HH:mm' }}</span>
        <span class="spacer"></span>
        <button type="button" class="ov-gomb" (click)="tervezetXml()">Tervezet XML</button>
      </div>
      <div class="eafa-osszeg" *ngIf="t.osszegzo">
        <div class="tetel"><span>Fizetendő</span><b>{{ t.osszegzo.fizetendo | number:'1.0-0' }} eFt</b></div>
        <div class="tetel"><span>Levonható</span><b>{{ t.osszegzo.levonhato | number:'1.0-0' }} eFt</b></div>
        <div class="tetel osszeg"><span>Különbözet</span><b>{{ t.osszegzo.kulonbozet | number:'1.0-0' }} eFt</b></div>
      </div>
      <div class="tabla-wrap" *ngIf="t.sorok?.length">
        <table class="n-racs">
          <thead><tr><th>Sor</th><th>Megnevezés</th><th class="num">Adóalap</th><th class="num">Adó</th></tr></thead>
          <tbody>
            <tr *ngFor="let r of t.sorok"><td>{{ r.sor }}</td><td>{{ r.megnevezes }}</td>
              <td class="num">{{ r.alap | number:'1.0-0' }}</td><td class="num">{{ r.ado | number:'1.0-0' }}</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <p class="halvany" style="font-size:.8em">
      Megjegyzés: az 1–5. NAV-lépések (gépi ÁFA-bevallás beküldése) a NAV eVAT M2M kapcsolat élesítése után
      működnek. Az <b>ÁFA-analitika</b> (fent, könyvelésből vagy Online Számla adatból) ettől függetlenül kész.
    </p>
  </div>

  <!-- Analitika összesítő -->
  <ng-container *ngIf="bevallas?.analitika as a">
    <p class="halvany" style="margin:8px 16px 0">
      Forrás: <b>{{ a.forras === 'osa' ? 'Online Számla (NAV) adatai' : 'könyvelt tételek' }}</b>
      <span *ngIf="a.forras === 'osa' && a.szamla_db != null"> · {{ a.szamla_db }} számla</span>
    </p>
    <div class="eafa-osszeg">
      <div class="tetel"><span>Fizetendő ÁFA</span><b>{{ a.fizetendo_afa | number:'1.0-0' }} Ft</b></div>
      <div class="tetel"><span>Levonható ÁFA</span><b>{{ a.levonhato_afa | number:'1.0-0' }} Ft</b></div>
      <div class="tetel osszeg" [class.piros]="a.elszamolando_afa > 0" [class.zold]="a.elszamolando_afa <= 0">
        <span>Elszámolandó</span><b>{{ a.elszamolando_afa | number:'1.0-0' }} Ft {{ a.elszamolando_afa > 0 ? '(fizetendő)' : '(visszaigényelhető)' }}</b>
      </div>
    </div>
    <div class="tabla-wrap" *ngIf="a.csoportok?.length">
      <table class="naplo-tabla">
        <thead><tr><th>Típus</th><th class="num">ÁFA-kulcs</th><th>Bevallási sor</th><th class="num">Db</th><th class="num">Nettó</th><th class="num">ÁFA</th><th class="num">Bruttó</th></tr></thead>
        <tbody>
          <tr *ngFor="let g of a.csoportok">
            <td>{{ g.tipus }}</td>
            <td class="num">{{ kulcsSzazalek(g.afa_kulcs) }}</td>
            <td>{{ g.bevallas_sor || '—' }}</td>
            <td class="num">{{ g.db }}</td>
            <td class="num">{{ g.netto | number:'1.0-0' }}</td>
            <td class="num">{{ g.afa | number:'1.0-0' }}</td>
            <td class="num">{{ g.brutto | number:'1.0-0' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <div class="ures" *ngIf="!bevallas?.letezik">
    <ion-icon name="documents-outline"></ion-icon>
    Válassz időszakot és forrást, majd <b>Áfa-analitika összeállítása</b> – a könyvelt tételekből,
    vagy közvetlenül a NAV <b>Online Számla</b> adataiból (könyvelés nélkül is).
  </div>

  <!-- Korábbi időszakok -->
  <div class="tabla-wrap" *ngIf="bevallasok.length">
    <h4 class="szekcio">eÁFA időszakok</h4>
    <table class="naplo-tabla">
      <thead><tr><th>Időszak</th><th>Állapot</th><th>NAV státusz</th><th>Utolsó művelet</th></tr></thead>
      <tbody>
        <tr *ngFor="let b of bevallasok">
          <td>{{ b.idoszak }}</td>
          <td>{{ b.allapot }}</td>
          <td>{{ b.nav_status || '—' }}</td>
          <td>{{ b.utolso_muvelet || '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<!-- ═══ Beküldött bevallás módosítása ═══ -->
<ion-modal [isOpen]="!!modositasAblak" (didDismiss)="modositasAblak = null" cssClass="bevsor-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ modositasCim }} – {{ idoszak }}</ion-title></ion-toolbar></ion-header>
    <div class="modositas-ablak" *ngIf="modositasAblak as m">
      <p class="halvany" *ngIf="m.fajta === 'SELF_CHECK'">
        Az önellenőrzés a <b>teljes</b> analitikát újraküldi (a mostani könyvelésből), az eredeti bevallásra hivatkozva. A 04-es lapon a
        kötelezettség változását a program számolja az eredeti és az új összegzőből. Növekedésnél önellenőrzési pótlék jár: az összegét a
        NAV pótlékkalkulátorával számold (Ügyféliránytű → Kalkulátorok → Pótlékszámítás), és írd be ide.
      </p>
      <p class="halvany" *ngIf="m.fajta === 'CORRECTION'">A helyesbítés a teljes analitikát újraküldi, az eredeti bevallásra hivatkozva – 04-es lap és pótlék nélkül.</p>
      <p class="halvany" *ngIf="m.fajta === 'JAVITAS'">A javítás a NAV értesítő levelére megy: ugyanazzal a jelleggel, mint a hibásnak minősített bevallás, és a levélben szereplő vonalkóddal.</p>

      <label class="mez" *ngIf="m.fajta === 'JAVITAS'"><span>Vonalkód (10 jegy)</span>
        <input type="text" [(ngModel)]="m.vonalkod" maxlength="10" inputmode="numeric" placeholder="0123456789"></label>
      <ng-container *ngIf="m.fajta === 'SELF_CHECK'">
        <label class="mez"><span>Általánostól eltérő ok</span>
          <select [(ngModel)]="m.ok"><option *ngFor="let o of potlekOkok" [value]="o.v">{{ o.c }}</option></select></label>
        <label class="mez" *ngIf="m.ok !== '01'"><span>Önellenőrzési pótlék (Ft)</span>
          <input type="number" min="0" step="1" [(ngModel)]="m.potlek" placeholder="a NAV kalkulátora szerint"></label>
      </ng-container>
      <label class="mez" *ngIf="m.kellEredeti"><span>Eredeti különbözet (eFt)</span>
        <input type="number" step="1" [(ngModel)]="m.eredeti_kulonbozet_ezer" placeholder="a beküldött bevallás 83. sora"></label>
      <p class="halvany" style="font-size:12px">Ha a módosítás kötelezettség-csökkenést mutat, az összeg az adószámlán marad (NO_RETURN); kiutalást a program nem kér.</p>
      <div class="gombok">
        <button type="button" class="ov-gomb fo" (click)="modositasIndit()">Előkészítés</button>
        <span class="spacer"></span>
        <button type="button" class="ov-gomb" (click)="modositasAblak = null">Mégsem</button>
      </div>
    </div>
  </ng-template>
</ion-modal>
